import CloudDownloadRounded from '@material-ui/icons/CloudDownloadRounded';
import PageCenterContainer from '../../components/PageCenterContainer';
import PageHeader from '../../components/PageHeader';
import { getDocumentDownloadUrl, useExistingDocuments } from '../../misc/lib/documents';
import './DocumentsPage.scss';

const DocumentsPage = () => {
  const documents = useExistingDocuments();

  return (
    <PageCenterContainer>
      <div className="documentspage-container">
        <PageHeader text="Letölthető dokumentumok" />
        <div className="documentspage-list">
          { documents.map((d, i) => (
            <div key={ i } className="documentspage-doc-card">
              <h2>{ d.name }</h2>
              <div onClick={ () => {
                getDocumentDownloadUrl(d.id).then((url) => {
                  window.open(url, '_blank');
                });
              } }>Letöltés <CloudDownloadRounded color="inherit" /></div>
            </div>
          )) }
        </div>
      </div>
    </PageCenterContainer>
  );
};

export default DocumentsPage;
